const Url_V1 = "https://gps.id";
const Url_V2 = "https://dev-seen.gps.id";

export { Url_V1, Url_V2 };
